import { Modal, Button } from "react-bootstrap";

const DeleteChWarningModal = ({ showModal, setShowModal, handleConfirmDelete,children  }) => {
  // console.log("ch",children);

  const handleCloseModal = () => {
   
    setShowModal(false);
  };

  return (
    <>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-5" >Are you sure you want to delete the children: <span className="fw-bold clrgreen " >
        </span> ?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="danger" 
          onClick={handleConfirmDelete}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteChWarningModal;
